// extracted by mini-css-extract-plugin
export default {"imggrid":"procss_imggrid__NyClf"};